<template>
  <ProductOffers :config="config" />
</template>

<script>

export default {
  name: 'DepositsProducts',
  components: {
    ProductOffers: () => import('@/views/products/ProductOffers.vue')
  },
  data () {
    return {
      config: {
        accountType: 'TD'
      }
    }
  }
}
</script>
